import React from 'react';

import { ActionLink, BannerImage, Container } from './styles';

export type FraudBannerProps = {
  href: string;
  imageSrc: string;
  imageAlt?: string;
  actionLabel?: string;
  isMobile?: boolean;
  className?: string;
};

const FraudBanner = ({
  href,
  imageSrc,
  imageAlt = 'Fraudes em boletos — Cuidado com golpes usando boletos falsos',
  actionLabel = 'Saiba mais',
  isMobile = false,
  className,
}: FraudBannerProps): JSX.Element => {
  return (
    <Container className={className} $isMobile={isMobile}>
      <BannerImage src={imageSrc} alt={imageAlt} />
      <ActionLink
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={actionLabel}
        $isMobile={isMobile}
      >
        {actionLabel}
      </ActionLink>
    </Container>
  );
};

export default FraudBanner;
